export const en = {
  "header": {
    "brand": "CikaStudio",
    "tools": "Tools",
    "games": "Games",
    "about": "About"
  },
  "nav": {
    "tools": "Tools",
    "games": "Games",
    "about": "About"
  },
  "actions": {
    "copy": "Copy",
    "download": "Download",
    "clear": "Clear",
    "copied": "Copied!",
    "copyAll": "Copy All",
    "downloadTxt": "Download TXT",
    "generate": "Generate",
    "regenerate": "Regenerate",
    "format": "Format",
    "minify": "Minify",
    "validate": "Validate",
    "convert": "Convert"
  },
  "footer": {
    "privacy": "Privacy",
    "terms": "Terms",
    "email": "Contact",
    "moreTools": "More Tools",
    "copyright": "© {year} CikaStudio. All rights reserved."
  },
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "theme": {
    "light": "Light",
    "dark": "Dark"
  },
  "common": {
    "clientSide": "100% client-side",
    "noUpload": "No data upload",
    "noAccount": "No account required",
    "loading": "Loading...",
    "error": "Error",
    "success": "Success"
  },
  "unitConverter": {
    "title": "Unit Converter",
    "subtitle": "Convert between 10+ unit categories.",
    "privacy": "100% client-side",
    "searchPlaceholder": "Search categories or units...",
    "from": "From",
    "to": "To",
    "quickConversions": "Quick Conversions",
    "length": "Length",
    "weight": "Weight",
    "temperature": "Temperature",
    "area": "Area",
    "volume": "Volume",
    "speed": "Speed",
    "time": "Time",
    "data": "Data",
    "energy": "Energy",
    "m": "Meter",
    "km": "Kilometer",
    "cm": "Centimeter",
    "mm": "Millimeter",
    "mi": "Mile",
    "yd": "Yard",
    "ft": "Foot",
    "in": "Inch",
    "kg": "Kilogram",
    "g": "Gram",
    "mg": "Milligram",
    "t": "Metric Ton",
    "lb": "Pound",
    "oz": "Ounce",
    "c": "Celsius",
    "f": "Fahrenheit",
    "k": "Kelvin",
    "m2": "Square Meter",
    "km2": "Square Kilometer",
    "ha": "Hectare",
    "ac": "Acre",
    "ft2": "Square Foot",
    "l": "Liter",
    "ml": "Milliliter",
    "m3": "Cubic Meter",
    "gal": "Gallon (US)",
    "qt": "Quart (US)",
    "cup": "Cup (US)",
    "m/s": "Meter/Second",
    "km/h": "Kilometer/Hour",
    "mph": "Mile/Hour",
    "kn": "Knot",
    "s": "Second",
    "min": "Minute",
    "h": "Hour",
    "d": "Day",
    "wk": "Week",
    "mo": "Month (avg)",
    "y": "Year",
    "b": "Byte",
    "kb": "Kilobyte",
    "mb": "Megabyte",
    "gb": "Gigabyte",
    "tb": "Terabyte",
    "bit": "Bit",
    "j": "Joule",
    "kj": "Kilojoule",
    "cal": "Calorie",
    "kcal": "Kilocalorie",
    "wh": "Watt-Hour",
    "kwh": "Kilowatt-Hour"
  },
  "security": {
    "note": "🔒 All processing happens locally in your browser. No data is uploaded to any server."
  },
  "content": {
    "privacy": {
      "title": "Privacy & Security",
      "description": "🔒 All unit conversions happen locally in your browser. No measurement data is ever uploaded to any server."
    },
    "guide": {
      "title": "How to Use Unit Converter",
      "description": "Convert between 10+ unit categories instantly with accurate real-time results.",
      "steps": [
        {
          "title": "Select a category",
          "description": "Choose from length, weight, temperature, volume, area, speed, time, data, pressure, energy, and more."
        },
        {
          "title": "Enter your value",
          "description": "Type the value you want to convert and pick the source and target units. The result updates automatically as you type."
        },
        {
          "title": "Copy or bookmark",
          "description": "Copy the converted value to your clipboard, or bookmark common conversions for quick access later."
        }
      ]
    },
    "features": {
      "title": "Key Features",
      "items": [
        "10+ conversion categories with 100+ units",
        "Real-time results as you type",
        "Accurate formulas based on standard SI definitions",
        "Reverse conversion with a single click",
        "Clean, responsive interface for mobile and desktop",
        "100% client-side processing — zero data upload"
      ]
    },
    "faq": {
      "title": "Frequently Asked Questions",
      "items": [
        {
          "question": "Is my data sent to a server?",
          "answer": "No. All calculations are performed locally in your browser using JavaScript. No measurement data ever leaves your device."
        },
        {
          "question": "How accurate are the conversions?",
          "answer": "All conversions use standard SI definitions and internationally recognized conversion factors. Results are accurate to at least 6 decimal places for scientific and engineering use."
        },
        {
          "question": "Can I convert between unrelated categories?",
          "answer": "You can convert within any category (e.g., meters to feet), but not across categories (e.g., weight to temperature). Select the appropriate category for your needs."
        }
      ]
    },
    "related": {
      "title": "Related Tools",
      "tools": [
        {
          "name": "Percentage Calculator",
          "url": "/utility/percentage-calculator",
          "description": "Instant percentage calculations in your browser."
        },
        {
          "name": "Timestamp Converter",
          "url": "/utility/timestamp-converter",
          "description": "Convert between Unix timestamps and human-readable dates."
        },
        {
          "name": "Base64 Converter",
          "url": "/converter/base64",
          "description": "Encode and decode Base64 strings quickly and securely."
        }
      ]
    }
  }
};
